



















































import { listFactory } from '@/main/pages';
import { approveButton, rejectButton } from '@/main/utils/tableOperations';
import { showAlert, getMessageType, MessageTypeStatus } from '@/main/utils/notifications';

import _ from 'lodash';
import dayJs from 'dayjs';

import { apiProvider } from './api';
import { store } from './store/list';
import { NAME, RequestStatus, PENDING_STATUS, APPROVE, REJECT, CONFIRM, DMS3_INFO_TITLE, INVALID_FORM } from './constants';
import { REMARK } from '../PROrders/constants';

export default listFactory(NAME, store).extend({
	data() {
		return {
			showDialog: false,
			ReturnStatus: RequestStatus.PENDING,
			RejectedComments: '',
			ReqObj: {
				PartNo: null as string | null,
				AdjustmentType: null as number | null,
				AdjustmentQty: null as number | null,
				PartRecId: null as number | null,
				RequestStatusId: null as number | null,
				ReqReasonId: null as number | null,
				ApprovedById: null as number | null,
				CreatedById: null as number | null,
				UpdatedById: null as number | null,
				RequestRejectionCommt: null as string | null,
			},
			approverData: [] as any,
			isPendingSelected: false,
		};
	},
	methods: {
		validateRemark() {
			this.showDialog = true;
		},
		async bulkInventoryApprovalRequest() {
			this.showConfirm({
					message:  this.LocalizeChyboveHlasky('bulkApprovalConfirmationMessage'),
					title: this.LocalizePopisPoli('WMS_CONFIRM'),
					options: {
						confirmButtonText: this.Localize('Ano'),
					    cancelButtonText: this.Localize('Ne'),
						callback: async (action) => {
							if (action === CONFIRM) {
								this.startLoading();
								await apiProvider.bulkInventoryApproveReject( this.StatusId, this.WarehouseId,
								APPROVE,  // 1 : APPROVE
								this.RejectedComments);
								await this.tableData();	
								this.endLoading();
								(this.$refs.table as any).refreshLayout();
							}							
						}
					},
				});
		},
		async bulkInventoryRejectRequest() {
			// validaiton : reject comment is not  given
			if (_.isEmpty(this.RejectedComments.trim())) {
				showAlert({
					message: this.LocalizeChyboveHlasky(INVALID_FORM),
					title: this.LocalizeChyboveHlasky(DMS3_INFO_TITLE),
					options: {
						type: 'info'
					},
				});
			} else // reject comment is given, happy flow
			{
				this.showDialog = false;
				this.startLoading();
				await apiProvider.bulkInventoryApproveReject(
					this.StatusId,
					this.WarehouseId,
					REJECT, // 2: Reject
					this.RejectedComments,
				);
				this.RejectedComments = '';
				await this.tableData();
				this.endLoading();
			}
		},
		getColumnLabel(columnName:any) {
			return `${'* '}${this.Localize(columnName)}`;
		},

		async viewClick(event: any, cells: any) {
			if (event.data!.STATUS.toUpperCase() !== RequestStatus[RequestStatus.PENDING]) {
				showAlert({
					message: this.LocalizeChyboveHlasky('adjustmentAlreadyApproved'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
						closeOnPressEscape: true,
						closeOnClickModal: true,
					},
				});
				return;
			}
			this.RejectedComments = '';
			this.ReturnStatus = RequestStatus.PENDING;
			this.ReqObj = {
				PartNo: event.data!.ITEM_NO,
				AdjustmentQty: event.data!.ADJUSTMENT_QTY,
				AdjustmentType: event.data!.ADJUSTMENT_TYPE,
				PartRecId: event.data!.PART_REC_ID,
				RequestStatusId: this.ReturnStatus,
				ReqReasonId: event.data!.REQUEST_STATUS_ID,
				ApprovedById: this.pracovnik.PracovnikId,
				CreatedById: this.pracovnik.PracovnikId,
				UpdatedById: this.pracovnik.PracovnikId,
				RequestRejectionCommt: this.RejectedComments,
			};
		},
		async approveRejectPartInventory() {
			this.ReqObj.RequestRejectionCommt = this.RejectedComments;
			this.ReqObj.RequestStatusId = this.ReturnStatus;

			const requestType = this.LocalizePopisPoli(RequestStatus[this.ReturnStatus || RequestStatus.PENDING]);
			const emailDto = {
				SenderId: this.ReqObj.ApprovedById,
				ReceiverId: this.ReqObj.CreatedById,
				PartNo: this.ReqObj.PartNo,
				RequestType: requestType,
				EmailTemplateId: '',
			};
			this.startLoading();
			const { data: invAdjustmentResp } = await apiProvider.approveInventoryAdjustment(this.ReqObj);
			if (invAdjustmentResp === RequestStatus.APPROVED) {
				showAlert({
					message: this.LocalizeAndReplace(this.LocalizeChyboveHlasky('ApprovInvenAdSuccessMsg'), { key: '<PART_NO>', value: `${this.ReqObj.PartNo} : ${requestType}` }),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
						closeOnPressEscape: true,
						closeOnClickModal: true,
					},
				});
				await apiProvider.sendEmailNotification(emailDto);
			}
			if (invAdjustmentResp === -1) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('AdjustQtyLessThanAvaQty'), options: { type: 'error' }, localizeMessage: false });
			}
			this.endLoading();
		},
		onReasonUpdate() {
			this.RejectedComments = '';

			if (this.ReturnStatus !== null) {
				this.isPendingSelected = true;
			} else {
				this.isPendingSelected = false;
			}
		},
		modalLabel(): string {
			return this.LocalizeFormular('approveRejectModel');
		},
		async filterClick() {
			if(this.StatusId != PENDING_STATUS && !this.filter.Uploaded_BulkInventory_Id){
				 showAlert({
					message: this.LocalizeChyboveHlasky('bulkInventoryIdRequired'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: getMessageType(MessageTypeStatus.INFO),
					},
				});
				return;
			}
			this.startLoading();
			this.filter.IsBullkActive = this.filter && this.dropdownList.BulkInventoryStatus && this.WarehouseId != null
				? this.dropdownList.BulkInventoryStatus[this.WarehouseId] === true
				: false;
			await this.tableData();
			this.endLoading();
		},
		generateDealerCodeForExport(): string {
			type WarehouseDropdownItem = { Value: number | string; Text: string };
			const warehouseList = this.dropdownList.WarehouseId as WarehouseDropdownItem[];
			const warehouseItem = warehouseList.find(item => item.Value === this.WarehouseId);
			const warehouseText = warehouseItem?.Text || '';
			const dealerCode = warehouseText.match(/\(([^)]+)\)/)?.[1] || '';
			return dealerCode;
		},
		async exportFun() {
			const headerData = [
				[this.LocalizePopisPoli('REPORT_DATE'), `\t${dayJs(new Date()).format('YYYY/MM/DD')}`],
				[this.LocalizePopisPoli('USER_NAME'), `${this.loggedUser.Jmeno} ${this.loggedUser.Prijmeni}`],
				[this.LocalizePopisPoli('DP_DEALER_KVPS'), this.generateDealerCodeForExport()],
				[''],
			];
			await this.exportData(headerData);
		},
	},
	computed: {
	},
});
